export const INTRO_ROUTE_PATHSEGMENT = '/intro';

export const LOGIN_ROUTE_PATHNAME = `${ INTRO_ROUTE_PATHSEGMENT }/login`;

export const INCOMPLETE_SESSION_EXPIRED_ROUTE_PATHNAME = `${ INTRO_ROUTE_PATHSEGMENT }/session-expired`;
